import { render, staticRenderFns } from "./EditDatasetList.vue?vue&type=template&id=800a02c2"
import script from "./EditDatasetList.vue?vue&type=script&lang=js"
export * from "./EditDatasetList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports